export class SubProduct {
  constructor(
    public id: number = 0,
    public name: string = '',
    public position: number = null,
    public image: string = ''
  ) {}
}
